<template>
    <div class="container">
        <div class="logo-top-block">
            <img class="logo" src="/img/logo.svg" alt="" />
            <img src="/img/fridge.svg" alt="" />
        </div>
        <div class="content-block pt60">
            <div class="white-bg-block h700">
                <div class="closed-page-3">
                    <span class="fs30 medium">Позвоните на номер </span>
                    <span class="fs44 medium">{{phoneNumber}}</span>
                    <span class="fs20">После ответа робота, введите код <br />холодильника для начала покупок.</span>
                    <span class="spec-code">{{storeKey}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Registration',
        data() {
            return {
                phoneNumber: '',
                storeKey: '',
                timeout: null,
            };
        },
        created() {

        },
        mounted() {
            this.init();
            this.phoneNumber = this.$route.params.phone_number;
            this.storeKey = this.$route.params.registration_code;
            let elem = this;
            this.timeout = setTimeout(function () {
                elem.$router.push('/');
            }, 90000);
        },
        beforeDestroy() {
            clearTimeout(this.timeout);
        },
        methods: {
            activateTerminal() {
                if (this.key) {
                    this.$api.post('/activate/', {
                        code: this.key
                    }).then((response) => {
                        if (response.data.key) {
                            localStorage.setItem('devices_channel_key', response.data.key);
                            localStorage.setItem('qr_code_url', response.data.qr_code_url);
                            this.init();
                        }
                    });
                }
            },
            login() {
                this.$router.push('/login?terminal_key=' + localStorage.getItem('devices_channel_key'));
            },
            init() {
                if (localStorage.getItem('devices_channel_key')) {
                    this.$store.state.isActivated = true;
                }

                this.qr_code_url = localStorage.getItem('qr_code_url');
                this.devices_channel_key = localStorage.getItem('devices_channel_key');

                if (this.devices_channel_key) {
                    this.$root.$emit('settingSocket', this.devices_channel_key);
                }
            }
        },
    };
</script>

<style>
</style>
